import { useLanguage } from '../contexts/LanguageContext';
import { fr } from '../translations/fr';
import { en } from '../translations/en';

const translations = {
  fr,
  en
};

export const useTranslation = () => {
  const { language } = useLanguage();
  
  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    
    for (const k of keys) {
      if (value && value[k]) {
        value = value[k];
      } else {
        console.warn(`Translation missing for key: ${key} in language: ${language}`);
        return key; // Return the key if translation is missing
      }
    }
    
    return value;
  };

  return { t, language };
};


